import api from "@/services/api";

const state = {
  runs: [],
};

const mutations = {
  SET_RUNS(state, runs) {
    state.runs = runs;
  },
};

const actions = {
  async getPayrollRuns({ commit }) {
    try {
      const res = await api.get("/payroll");
      commit("SET_RUNS", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching payroll runs:", error.message);
      throw error;
    }
  },

  async runPayroll({ dispatch }, payload) {
    try {
      const result = await api.post("/payroll/run", payload);
      await dispatch("getPayrollRuns");
      return result.data;
    } catch (error) {
      console.error("Error running payroll:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
